/**
 * Browser state that must not outlive a session. Kept in its own module with no imports so
 * `appContext` can clear it without importing the components that own it, which import `appContext`.
 * Each module that holds per-session state registers a reset when it loads.
 */
export const RULE_FEEDBACK_STORAGE_PREFIX = 'rx-rule-feedback:';

const resets = new Set<() => void>();

export const registerSessionReset = (reset: () => void) => {
  resets.add(reset);
};

/** Reset in-memory stores that hold data from the current session. */
export const resetSessionMemory = () => {
  resets.forEach(reset => reset());
};

/** Remove the saved rule feedback verdicts so the next account does not see them. */
export const clearRuleFeedbackStorage = () => {
  try {
    const keys = Array.from({ length: localStorage.length }, (_, index) => localStorage.key(index));
    keys.forEach(key => {
      if (key?.startsWith(RULE_FEEDBACK_STORAGE_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  } catch {
    // Storage can be unavailable (private mode); there is nothing to clear then.
  }
};
